angular.module('mercury.dialogs.payrolldetails')
.controller('PayrollDetailsDialogCtrl', ["localStorageService", "$scope", "dialog", function(localStorageService, $scope, dialog) {
  $scope.dontShowAgain = localStorageService.get('dismissFlag.payrollDetailsDialog');

  $scope.setFlag = function() {
    console.log($scope.dontShowAgain);
    localStorageService.set('dismissFlag.payrollDetailsDialog', $scope.dontShowAgain);
  };

  $scope.close = function() {
    dialog.close();
  };

  $scope.stopPropagation = function($event) {
    $event.stopPropagation();
  };
}]);
